function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10 2a8 8 0 100 16 8 8 0 000-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 11v2H5v-2h2zm8 0v2H9v-2h6zM7 7v2H5V7h2zm8 0v2H9V7h6z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 5,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.266 14.325l-3.307 3.308-1.225-1.226-1.234 1.234 2.459 2.459 4.541-4.541z"
}));

function SvgQMcScoredTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref);
}

export default SvgQMcScoredTypeIcon;